// ** Core JWT Import
import useJwt from '@src/@core/auth/jwt/useJwt'

const { jwt } = useJwt({loginEndpoint: process.env.REACT_APP_BASE_URL + '/api/adminLogin'})

export default jwt
